// Stable public recipe imported by ImagesGrid. Apps can alias this module while
// importing the defaults directly to avoid a circular dependency.
export * from './imagesGrid.variants.defaults';
